import script from "./Meta.vue?vue&type=script&setup=true&lang=js"
export * from "./Meta.vue?vue&type=script&setup=true&lang=js"

import "./Meta.vue?vue&type=style&index=0&id=b1c9c412&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1c9c412"]])

export default __exports__